import { FormField } from 'components/shared/form';
import { CommercialRentRollUnit, RentRollTableColumn } from 'types/underwriting/income-approach';
import { RENT_ROLL_LABELS } from '../../constants';
import Form from 'mobx-react-form';
import { IncomeApproachBasisType, INCOME_APPROACH_BASIS_TYPES } from 'shared/calculations/incomeApproach';

export const rentRollFormFields: FormField[] = [
  {
    name: 'incomeApproach',
    fields: [
      {
        name: 'commercial',
        fields: [
          {
            name: 'rentRoll',
            type: 'array',
            value: [],
          },
          {
            name: 'rentRoll[]',
            fields: [
              {
                name: 'number',
                type: 'text',
                value: '',
              },
              {
                name: 'use',
                type: 'text',
                value: '',
              },
              {
                name: 'tenant',
                type: 'text',
                value: '',
              },
              {
                name: 'squareFootage',
                type: 'number',
                value: 0,
              },
              {
                name: 'leaseStatus',
                type: 'text',
                value: '',
              },
              {
                name: 'rent',
                type: 'number',
                value: 0,
              },
            ],
          },
          {
            name: 'vcLossPercentage',
            type: 'number',
            value: 0,
          },
        ],
      },
    ],
  },
];

export const rentRollFormHelpers = {
  getUnitsTableColumns(isProjectedRentRoll: boolean = false): RentRollTableColumn[] {
    const columns: RentRollTableColumn[] = [
      {
        data: 'index',
        value: '#',
      },
      {
        data: 'number',
        value: RENT_ROLL_LABELS.UNIT_NUMBER,
      },
      {
        data: 'tenant',
        value: RENT_ROLL_LABELS.TENANT,
      },
      {
        data: 'use',
        value: RENT_ROLL_LABELS.USE,
      },
      {
        data: 'leaseStatus',
        value: RENT_ROLL_LABELS.LEASE_STATUS,
      },
      {
        data: 'squareFootage',
        value: RENT_ROLL_LABELS.SQUARE_FOOTAGE,
      },
      {
        data: 'rent',
        value: RENT_ROLL_LABELS.BORROWER_MONTHLY_RENT,
      },
    ];

    if (isProjectedRentRoll) {
      columns.push({
        data: 'projectedRent',
        value: RENT_ROLL_LABELS.PROJECTED_MONTHLY_RENT,
      });
    }
    columns.push(
      ...[
        {
          data: 'annualRent',
          value: `${isProjectedRentRoll ? 'Projected' : ''} ${RENT_ROLL_LABELS.ANNUAL_RENT}`,
        },
        {
          data: 'rentPerSF',
          value: `${isProjectedRentRoll ? 'Projected' : ''} ${RENT_ROLL_LABELS.RENT_PER_SF}`,
        },
      ]
    );

    return columns;
  },
  getCommercialIncomeTotal(form: Form, type: IncomeApproachBasisType) {
    const rentRollField = form.$('incomeApproach.commercial.rentRoll') || [];
    const rentRoll = rentRollField.value;
    const rentField = type === INCOME_APPROACH_BASIS_TYPES.borrower ? 'rent' : 'projectedRent';
    const total = rentRoll.reduce((sum: any, unit: CommercialRentRollUnit) => sum + (unit[rentField] || 0), 0);
    return total * 12;
  },
};
